import React, { useState } from "react";
import { Col, Row, Form, Button, message } from "antd";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
// component
import BranchShopLogo from "./component/branch_shop_logo";
import BranchShopName from "./component/branch_shop_name";
import BranchShopId from "./component/branch_shop_id";
import BranchShopPhone from "./component/branch_shop_phone";
import BranchShopEmail from "./component/branch_shop_email";
import BranchShopAddress from "./component/branch_shop_address";
import BranchShopAdressSuburb from "./component/branch_shop_address_suburb";
import BranchShopAdressCity from "./component/branch_shop_address_city";
import BranchShopAdressState from "./component/branch_shop_address_state";
import BranchShopAdressPostCode from "./component/branch_shop_address_post_code";
// redux
import { addBranch } from "../../store/branch/branch.action";

import "./style.css";

const wrapperCol = {
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 18,
    offset: 0,
  },
};

const labelCol = {
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 6,
    offset: 0,
  },
};

const BranchShopAdd = () => {
  // -------------------------- VAR --------------------------
  const [form] = Form.useForm();
  const { t } = useTranslation("translation", { keyPrefix: "branch" });
  const navigate = useNavigate();
  // -------------------------- STATE --------------------------
  const [logo, setLogo] = useState("");
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------

  const onSelectLogo = (uri) => {
    setLogo(uri);
    form.setFieldsValue({ logo: uri });
  };

  const onSelectAddress = (values) => {
    form.setFieldsValue(values);
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- DATA FUNCTION --------------------------

  const onFinish = (values) => {
    setLoading(true);
    const branch = {
      ...values,
      logo: logo,
    };
    dispatch(
      addBranch({ branch }, (response) => {
        setLoading(false);
        if (response?.status === 200) {
          message.success("Add Branch Successfully!");
          navigate("/branchs/detail/" + response.data);
        }
        if (response?.status === 500) {
          message.error(response?.data || "Failed");
        }
      })
    );
  };

  const onFinishFailed = (error) => {
    console.log({ error });
  };

  // -------------------------- RENDER --------------------------

  const renderForm = () => {
    const disabled = loading;
    return (
      <Form
        name="edit_form"
        autoComplete="off"
        form={form}
        labelCol={labelCol}
        wrapperCol={wrapperCol}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[16, 0]}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <BranchShopLogo
              disabled={disabled}
              logo={logo}
              onSelect={onSelectLogo}
            />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BranchShopName disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BranchShopId disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BranchShopPhone disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BranchShopEmail disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={24}>
            <BranchShopAddress disabled={disabled} onSelect={onSelectAddress} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BranchShopAdressSuburb disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BranchShopAdressCity disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BranchShopAdressState disabled={disabled} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <BranchShopAdressPostCode disabled={disabled} />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <Form.Item style={{ marginBottom: 0, float: "right" }}>
              <Button
                type="primary"
                htmlType="submit"
                className="form-button save"
                loading={loading}
              >
                {t("save")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  };

  // -------------------------- MAIN --------------------------

  return (
    <Row gutter={[16, 5]}>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderForm()}
      </Col>
    </Row>
  );
};

export default BranchShopAdd;
